module.exports = __webpack_public_path__ + "img/Grand Cash Slots.b9667d12.png";